import IdoDetailWrapper from "app/components/ido-details/ido-details-wrapper";
import CircleLoader from "app/components/loader/CircleLoader";
import { FC, ReactNode, Suspense, useMemo } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import RefStatisticsById from "../components/RefStatisticsById/RefStatisticsById";
import { Path } from "../constants/paths";
import { useAuth } from "../hooks";
import useSEOByRoute from "../hooks/useSEOByRoute";
import AppMainPage from "./app-main.page";
import BridgePage from "./Bridge";
import ClaimMaintenancePage from "./claim-maintenance";
import DashboardPage from "./dashboard.page";
import OnboardingPage from "./onboarding.page";
import RefStatistics from "./RefStatistics";

export type Params = {
  idoId: string;
  inoId: string;
};

type AppRoute = {
  path: Path;
  component?: ReactNode;
  exact?: boolean;
  noLayout?: boolean;
};

const publicRoutes: AppRoute[] = [
  {
    path: Path.APP_MAIN,
    component: <AppMainPage />,
    exact: true,
    noLayout: true,
  },
  {
    path: Path.IDO,
    component: <IdoDetailWrapper />,
    exact: true,
    noLayout: true,
  },
  {
    path: Path.DASHBOARD,
    component: <DashboardPage />,
    exact: true,
    noLayout: true,
  },
  {
    path: Path.BUILD_KARMA,
    component: <OnboardingPage />,
    exact: true,
    noLayout: true,
  },
  {
    path: Path.BUILD_KARMA_SLASH,
    component: <OnboardingPage />,
    exact: true,
    noLayout: true,
  },
  // {
  //   path: Path.CLAIM,
  //   component: <Claim />,
  //   exact: true,
  //   noLayout: true,
  // },
  {
    path: Path.CLAIM,
    component: <ClaimMaintenancePage />,
    exact: true,
    noLayout: true,
  },
  {
    path: Path.BRIDGE,
    component: <BridgePage />,
    exact: true,
    noLayout: true,
  },
];

const privateRoutes: AppRoute[] = [
  {
    path: Path.REF_STATISTICS,
    component: <RefStatistics />,
    exact: true,
    noLayout: true,
  },
  {
    path: Path.REF_STATISTICSBYID,
    component: <RefStatisticsById />,
    exact: true,
    noLayout: true,
  },
];

const Pages: FC = () => {
  const isAuth = useAuth();
  // Use the SEO hook to update SEO data based on current route
  useSEOByRoute();

  const routes = useMemo(
    () => (isAuth ? [...publicRoutes, ...privateRoutes] : publicRoutes),
    [isAuth]
  );

  return (
    <div>
      <Suspense fallback={<CircleLoader />}>
        <Switch>
          {routes.map(({ path, exact, component }) => (
            <Route path={path} exact={exact} key={path}>
              {component}
            </Route>
          ))}
          <Redirect to={Path.APP_MAIN} />
        </Switch>
      </Suspense>
    </div>
  );
};

export default Pages;
